<template>
  <div>
    <v-form v-model="mainFormValid">
      <v-text-field
        v-model="internalValue.userLogin"
        :rules="$options.rules.userLogin"
        :error-messages="userLoginErrorMessage"
        :label="$t('user.login')"
        prepend-icon="mdi-account"
        type="text"
        @input="change"
      />

      <roles-field
        v-model="internalValue.roles"
        @input="change"
      />

      <v-text-field
        v-model="internalValue.firstName"
        :rules="$options.rules.firstName"
        :label="$t('user.firstName')"
        prepend-icon="mdi-account-details"
        type="text"
        @input="change"
      />

      <v-text-field
        v-model="internalValue.lastName"
        :rules="$options.rules.lastName"
        :label="$t('user.lastName')"
        prepend-icon="mdi-account-details"
        type="text"
        @input="change"
      />

      <v-text-field
        v-if="hasEmail"
        v-model="internalValue.email"
        :rules="$options.rules.email"
        :label="$t('user.email')"
        prepend-icon="mdi-email"
        type="mail"
        @input="change"
      />

      <ag-password-field
        v-if="showPassword"
        v-model="internalValue.password"
        :password-label="$t('user.changePassword')"
        :confirm-label="$t('user.confirmPassword')"
        @input="change"
      />

      <ag-language-field
        v-model="internalValue.lang"
        :label="$t('general.language')"
        @input="change"
      />
    </v-form>
  </div>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import AgPasswordField from 'src/components/common/AgPasswordField'
import AgLanguageField from 'src/components/common/AgLanguageField'
import RolesField from 'src/components/field/RolesField'

export default {
  name: 'UserForm',
  components: {
    AgPasswordField,
    AgLanguageField,
    RolesField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    forbiddenUserList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    internalValue: null,
    mainFormValid: false,
  }),
  computed: {
    isValidUser () {
      return this.mainFormValid
    },
    userLoginErrorMessage () {
      return this.forbiddenUserList.includes(this.internalValue.userLogin)
        ? this.$t('error.form.userExist')
        : null
    },
    hasEmail () {
      return this.internalValue.roles.includes('ADMIN')
        || this.internalValue.roles.includes('OWNER')
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
        this.$emit('validate', this.isValidUser)
      },
    },
    isValidUser: {
      immediate: true,
      handler () {
        this.$emit('validate', this.isValidUser)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.isValidUser)
    },
  },
  rules: {
    userLogin: [
      FormRules.required('error.form.required'),
      FormRules.maxLength('error.form.maxLength', { length: 15 }),
      FormRules.minLength('error.form.minLength', { length: 2 }),
      FormRules.noSpaces('error.form.noSpaces'),
    ],
    firstName: [
      FormRules.required('error.form.required'),
    ],
    lastName: [
      FormRules.required('error.form.required'),
    ],
    email: [
      FormRules.required('error.form.required'),
      FormRules.email('error.form.email'),
    ],
  },
}
</script>
